import React from 'react'
import ViewAdmins from '../../components/admin/viewAdmin/ViewAdmins'
import SidebarNew from '../../components/sidebar/SidebarNew'

function ViewAdminPage() {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col">
        <div className="flex">
          <div className="h-full z-10 overflow-y-auto">
            <SidebarNew />
          </div>
          <div className="lg:flex-1 overflow-auto scrollbar-hide h-screen w-full md:z-10 p-4 lg:p-10 md:p-10">
            <ViewAdmins />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewAdminPage